import Component from "../abstracts/Component";
import TrackingComponent from "../components/TrackingComponent";
import VerifyRegisterBySmsComponent from "./VerifyRegisterBySmsComponent";
import {IS_CHINA} from "../utils/Environment";

const doAjax = options => {
  options = $.extend(
    true,
    {},
    {
      cache: false,
      async: true,
      type: "GET"
    },
    options
  );
  return $.ajax(options);
};

export default class RegistrationComponent extends Component {
  static get SELECTORS() {
    return {
      STORE_SELECT: ".js-store-select",
      STORE_SELECT_ERROR: "span[id='storeNumber.error']",
      DATA_PICKER: "input[name='birthDate']",
      DATA_PICKER_ERROR: "span[id='birthDate.error']",
      EMAIL_SELECT: ".js-kr-email-select",
      EMAIL_INPUT: "#emailDomain",
      EMAIL_SELECT_ERROR: "span[id='emailDomain.error']",
      SUBMIT_BUTTON: ".js-register-form-check",
      REGISTER_FORM: "#registerForm",
      page: ".p-register",
      pageWrapper: "#wrapper",
      registerForm: "[data-register-form]",
      expireTime: ".js-expire-vcode",
    };
  }

  static get EVENT() {
    return {
      SELECT_2_CLOSE: "select2:close",
      FLAT_PICKRC_CLOSE: "flatpickrclose",
      PAGE_LOAD: "DOMContentLoaded"
    };
  }

  static get CLASSES() {
    return {
      HIDE: "d-none",
      ERROR: "error"
    };
  }

  render() {
    this.bindValidation();
    this.bindEvents();
    this.doRegister();
  }

  constructor() {
    super();
    this.trackingComponent = new TrackingComponent();
    this.verifyRegisterBySmsComponent = new VerifyRegisterBySmsComponent();
  }

  bindValidation() {
    const storeSelect = document.querySelector(
      RegistrationComponent.SELECTORS.STORE_SELECT
    );
    const emailSelect = document.querySelector(
      RegistrationComponent.SELECTORS.EMAIL_SELECT
    );

    if (storeSelect != null) {
      $(storeSelect).on(RegistrationComponent.EVENT.SELECT_2_CLOSE, function(
        event
      ) {
        const element = event.target;

        if (element.classList === storeSelect.classList) {
          if ($(element).val() === "") {
            element.classList.add(RegistrationComponent.CLASSES.ERROR);
            document
              .querySelector(RegistrationComponent.SELECTORS.STORE_SELECT_ERROR)
              .classList.remove(RegistrationComponent.CLASSES.HIDE);
          } else {
            element.classList.remove(RegistrationComponent.CLASSES.ERROR);
            document
              .querySelector(RegistrationComponent.SELECTORS.STORE_SELECT_ERROR)
              .classList.add(RegistrationComponent.CLASSES.HIDE);
          }
        }
      });
    }

    if (emailSelect != null) {
      $(emailSelect).on(RegistrationComponent.EVENT.SELECT_2_CLOSE, function(
        event
      ) {
        const element = event.target;

        if (element.classList === emailSelect.classList) {
          if ($(element).val() === "") {
            element.classList.add(RegistrationComponent.CLASSES.ERROR);
            document
              .querySelector(RegistrationComponent.SELECTORS.EMAIL_SELECT_ERROR)
              .classList.remove(RegistrationComponent.CLASSES.HIDE);
          } else {
            element.classList.remove(RegistrationComponent.CLASSES.ERROR);
            document
              .querySelector(RegistrationComponent.SELECTORS.EMAIL_SELECT_ERROR)
              .classList.add(RegistrationComponent.CLASSES.HIDE);
          }
        }
      });
    }

    document.addEventListener(
      RegistrationComponent.EVENT.FLAT_PICKRC_CLOSE,
      e => {
        const element = document.querySelector(
            RegistrationComponent.SELECTORS.DATA_PICKER
          ),
          dateInput = element.nextSibling;

        if (element.value === "" || dateInput.value === "") {
          element.classList.add(RegistrationComponent.CLASSES.ERROR);
          dateInput.classList.add(RegistrationComponent.CLASSES.ERROR);
          document
            .querySelector(RegistrationComponent.SELECTORS.DATA_PICKER_ERROR)
            .classList.remove(RegistrationComponent.CLASSES.HIDE);
        } else {
          element.classList.remove(RegistrationComponent.CLASSES.ERROR);
          dateInput.classList.remove(RegistrationComponent.CLASSES.ERROR);
          document
            .querySelector(RegistrationComponent.SELECTORS.DATA_PICKER_ERROR)
            .classList.add(RegistrationComponent.CLASSES.HIDE);
        }
      }
    );

    const submitButton = document.querySelector(
      RegistrationComponent.SELECTORS.SUBMIT_BUTTON
    );

    if (submitButton != null) {
      submitButton.addEventListener("click", e => {
        const emailSelect = document.querySelector(
          RegistrationComponent.SELECTORS.EMAIL_SELECT
        );

        if ($(emailSelect).val() === "") {
          emailSelect.classList.add(RegistrationComponent.CLASSES.ERROR);
          document
            .querySelector(RegistrationComponent.SELECTORS.EMAIL_SELECT_ERROR)
            .classList.remove(RegistrationComponent.CLASSES.HIDE);
        } else {
          emailSelect.classList.remove(RegistrationComponent.CLASSES.ERROR);
          document
            .querySelector(RegistrationComponent.SELECTORS.EMAIL_SELECT_ERROR)
            .classList.add(RegistrationComponent.CLASSES.HIDE);
        }
      });
    }
  }

  bindEvents() {
    $(document).ready(function() {
      const emailInput = document.querySelector(
        RegistrationComponent.SELECTORS.EMAIL_INPUT
      );
      const emailSelect = document.querySelector(
        RegistrationComponent.SELECTORS.EMAIL_SELECT
      );

      if (emailInput != null && emailSelect != null) {
        // console.log(emailInput.value);
        emailSelect.value = emailInput.value;
        // console.log(emailSelect.value);
      }
    });

    document.addEventListener("DOMContentLoaded", function(event) {
      // console.log('DOM fully loaded and parsed');
    });
  }

  doRegister() {
    let ctx = this;
    // checks
    if (document.querySelector(RegistrationComponent.SELECTORS.REGISTER_FORM) === null) return;
    if (document.querySelector(RegistrationComponent.SELECTORS.REGISTER_FORM).classList.contains("js-validate-form-kr"))
    {
      return;
    }

    const form = document.querySelector(RegistrationComponent.SELECTORS.REGISTER_FORM);
    console.log("setting form event listener", form)

    form.addEventListener("submit", function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!window.RecaptchaComponent.getResponseFromWidget('registrationPage')) {
        // User have not completed the challenge
        return;
      }

      let endpoint = this.getAttribute("action");
      let payload = $(this).serialize();
      // go ajax
      doAjax({
        url: endpoint,
        data: payload,
        dataType: "html",
        success: response => {
          let res = new DOMParser().parseFromString(response, "text/html");
          //register success
          if (res.querySelector(RegistrationComponent.SELECTORS.page) &&
              res.querySelector(RegistrationComponent.SELECTORS.page).dataset.thanks == "true"
          ) {
            document.querySelector(RegistrationComponent.SELECTORS.pageWrapper).innerHTML = res.querySelector(RegistrationComponent.SELECTORS.pageWrapper).innerHTML;
            let params = ctx.trackingComponent.getTrackingPayloadData(res, true);
            ctx.trackingComponent.actions.register(params);
            window.scrollTo(0, 0);
          } else {
            //register error
            let isKr = (document.body.dataset.website === 'kr');
            if (isKr) {
              let newExpireTime = res.querySelector(RegistrationComponent.SELECTORS.expireTime);
              let oldExpireTime = document.querySelector(RegistrationComponent.SELECTORS.expireTime);
              if (typeof (newExpireTime) !== 'undefined' && newExpireTime !== null && typeof (oldExpireTime) !== 'undefined' && oldExpireTime !== null) {
                oldExpireTime.dataset.vdate = newExpireTime.dataset.vdate;
              }
              ctx.verifyRegisterBySmsComponent.createTimer();
              document.querySelector(RegistrationComponent.SELECTORS.REGISTER_FORM).innerHTML = res.querySelector(RegistrationComponent.SELECTORS.REGISTER_FORM).innerHTML;
              ctx.verifyRegisterBySmsComponent.sendClientTimeToServer();
            } else if (IS_CHINA) {
              document.querySelector(RegistrationComponent.SELECTORS.REGISTER_FORM).innerHTML = res.querySelector(RegistrationComponent.SELECTORS.REGISTER_FORM).innerHTML;
            } else {
              document.querySelector(RegistrationComponent.SELECTORS.registerForm).innerHTML = res.querySelector(RegistrationComponent.SELECTORS.registerForm).innerHTML;
            }
          }
        }
      });
    });
  }
}
